import React, { Fragment } from 'react';
import If from 'src/components/Shared/If/If';
import config from 'src/config/config';
import words from 'src/utils/words';

const PendingTransactionFundNoteTip: React.FC<{ allFunds?: boolean }> = ({
  allFunds = false,
}) => (
  <Fragment>
    <If test={!allFunds}>
      <span className="exclude">
        Account currently has a transaction pending.{' '}
        <a
          className="college-branded-link exclude"
          href={`${config.url}/usis/my-accounts/transactions`}
          rel="noopener noreferrer"
          target="_blank"
          title="View Pending Transactions"
        >
          View Details
        </a>
      </span>
    </If>
    <If test={allFunds}>
      <span className="exclude">
        Account currently has a transaction pending that will {words.redeem} all{' '}
        {words.shares}.{' '}
        <a
          className="college-branded-link exclude"
          href={`${config.url}/usis/my-accounts/transactions`}
          rel="noopener noreferrer"
          target="_blank"
          title="View Pending Transactions"
        >
          View Details
        </a>
      </span>
    </If>
  </Fragment>
);

export default PendingTransactionFundNoteTip;
